import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { validateToken, callApi } from "../../../lib/utils";
import { Button, Modal, Spinner } from "react-bootstrap";
import CustomLoader from "../../GenericComponents/CustomLoader";
import moment from "moment";
import { useSelector } from "react-redux";
import store from "../../../reducers/store";
import GenericTableFilterBar from "../../GenericComponents/GenericTableFilterBar";
import SymptomsHeader from "./SymptomsHeader";
import SymptomsList from "./SymptomsList";
import "../DrillDownPage.css";

function Symptoms() {
  const [symptomsList, setSymptomsList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);
  const currentPage = useSelector((state) => state?.tableFilter?.currentPage);
  const perPage = useSelector((state) => state?.tableFilter?.perPage);
  const pages = useSelector((state) => state?.appstate?.pages);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    validateToken((err) => {
      if (err) {
        // console.log(err);
        window.location = "/logout";
      }
      fetchData();
    });
  }, [currentPage, perPage]);

  const setPagination = (data) => {
    store.dispatch({ type: "SET_PAGINATION_PAGES", payload: { pages: data } });
  };

  const fetchData = () => {
    let params = {
      start: startDate,
      end: endDate,
      page: currentPage,
      limit: parseInt(perPage),
      timezone: moment.tz.guess(),
    };

    setLoading(true);
    callApi(`/api/patient/dashboard/symptoms/list`, params, "POST")
      .then((response) => {
        setSymptomsList(response?.data?.data?.symptoms);
        setSearchList(response?.data?.data?.symptoms);
        setPagination(response?.data?.data?.pagination?.pages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const filterRecordsBySearchText = (searchText) => {
    let filteredList = [];
    searchList.forEach((list) => {
      let shouldAdd = true;
      if (
        list.symptom.name.toUpperCase().search(searchText.toUpperCase()) ===
        -1
      ) {
        shouldAdd = false;
      }

      if (shouldAdd) {
        filteredList.push(list);
      }
    });
    setSymptomsList(filteredList);
  };

  return (
    <div className="drilldown-page">
      <CustomLoader loading={loading} />

      <SymptomsHeader />

      <GenericTableFilterBar pages={pages} title="" filterRecordsBySearchText={filterRecordsBySearchText}
      />

      <SymptomsList currentPage={currentPage} perPage={perPage} symptomsList={symptomsList} />
    </div>
  );
}

export default Symptoms;
